import { useParams, useNavigate } from 'react-router-dom';
import LevelsList from '../components/levels-list';
import { Loader } from '../components/loader';
import { ArrowLeft } from 'lucide-react';
import { useLevels } from '../hooks/use-course';

const LevelsPage = () => {
  const navigate = useNavigate();
  const { courseId } = useParams();

  const { data, isLoading, error } = useLevels(parseInt(courseId!, 10));

  if (isLoading) return <Loader />;

  if (error) {
    return (
      <div className="flex flex-col min-h-screen max-w-lg mx-auto bg-bg-main px-4 py-6">
        <h1 className="text-xl font-bold text-incorrect mb-4">Error</h1>
        <p className="text-title mb-2">
          {error.message === 'You do not have access to this course'
            ? 'Access Denied'
            : 'Failed to load course levels. Please try again.'}
        </p>
        <p className="text-sm text-subheading">{error.message}</p>
        <button
          onClick={() => navigate('/courses')}
          className="mt-4 bg-accent-purple text-white px-4 py-2 rounded-lg"
        >
          Back to My Courses
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen max-w-lg mx-auto bg-bg-main px-4 py-6">
      <header className="mb-6">
        <div className="flex items-center mb-4">
          <button
            onClick={() => navigate('/courses')}
            className="text-title hover:text-accent-purple transition-colors mr-4"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
          <div>
            <h1 className="text-xl font-bold text-title">
              {data?.course_name}
            </h1>
            <p className="text-subheading text-sm">Select a level to begin</p>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <LevelsList levels={data?.levels || []} courseId={courseId || ''} />
      </main>
    </div>
  );
};

export default LevelsPage;
